<template>
  <v-card>
    <v-card-title>View Mode</v-card-title>
    <v-select
      :items="['grid', 'slider']"
      label="View mode"
      v-model="modelValue"
      class="px-4"
    ></v-select>
  </v-card>
</template>

<script setup lang="ts">
import { useSettingsStore } from '@/stores/settings'
import { onMounted, ref, watch } from 'vue'

const props = defineProps<{
  selectedPlacement: string
}>()

const modelValue = ref()
const settingsStore = useSettingsStore()

onMounted(() => {
  modelValue.value =
    settingsStore.placements.placements[props.selectedPlacement].viewMode
})

watch(modelValue, () => {
  settingsStore.placements.placements[props.selectedPlacement].viewMode =
    modelValue.value
})
</script>
